/**
 * Do not edit directly
 * Generated on Fri, 26 Jan 2024 09:10:52 GMT
 */

export const SbFontFamilyRegular =
  '"National2-Regular", "Arial", "Helvetica", sans-serif'
export const SbFontFamilyMedium =
  '"National2-Medium", "Arial", "Helvetica", sans-serif'
export const SbFontFamilyBold =
  '"National2-Bold", "Arial", "Helvetica", sans-serif'
